import { useMemo } from "react"

type ReactRef<T> = React.Ref<T> | React.MutableRefObject<T>

export function mergeRefs<T>(...args: ReactRef<T>[]) {
  return function forwardRef(node: T | null) {
    args.forEach((ref: ReactRef<T>) => {
      if (ref == null) {
        return
      }
      if (typeof ref === "function") {
        ref(node)
        return
      }

      if (typeof ref === "object") {
        // @ts-ignore
        ref.current = node
        return
      }

      console.error(
        `mergeRefs cannot handle Refs of type boolean, number or string, received ref ${String(
          ref,
        )}`,
      )
    })
  }
}

export function useMergeRefs<T>(...args: ReactRef<T>[]) {
  return useMemo(() => mergeRefs(...args), [...args])
}
